// src/models/pedidos/TipoEntrega.js
export class TipoEntrega {
    constructor(
        id = 0,
        descricao = '',
        temTaxaEntrega = false,
        exibeApp = null,
    ) {
        this.id = id; // int
        this.descricao = descricao; // string
        this.temTaxaEntrega = temTaxaEntrega; // bool
        this.exibeApp = exibeApp; // bool?
    }
}
